import * as ActionTypes from '../actions/ActionTypes';
import TagsRecord from '../records/TagsRecord';
export default function TagsReducer(state = new TagsRecord(), action) {
  switch (action.type) {
    case ActionTypes.FETCH_TAG_DEFINITIONS_PENDING:
      return state.set('isRequesting', true);
    case ActionTypes.FETCH_TAG_DEFINITIONS_SUCCESS:
      return TagsRecord.fromTags(action.payload.results).merge({
        lastLoaded: new Date().getTime(),
        isRequesting: false,
        loadError: null
      });
    case ActionTypes.FETCH_TAG_DEFINITIONS_ERROR:
      return state.merge({
        isRequesting: false,
        loadError: action.payload
      });
    case ActionTypes.CREATE_TAG_SUCCESS:
    case ActionTypes.APPLY_TAG_TO_ARTICLES_SUCCESS:
      return state.setIn(['data', action.payload.id], action.payload);
    default:
      return state;
  }
}